import Link from 'next/link';
import useLocale from 'next-translate/useTranslation';
import React from 'react';

const STEPS: Array<[string, string, string]> = [
  [
    '01',
    'Describe or upload',
    'Type a scene, or drop in a photo, reference clip or audio track to guide the shot.',
  ],
  [
    '02',
    'Pick a model and format',
    'Choose Seedance, Veo, Kling or others — widescreen, vertical or square, up to 4K.',
  ],
  [
    '03',
    'Generate and share',
    'Your clip renders in minutes with sound. Regenerate, extend or download in one click.',
  ],
];

const VideoSteps = () => {
  const { t } = useLocale('ai-videos');

  return (
    <section id='how-it-works' className='relative py-20 lg:py-28'>
      <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
        <div className='mb-14 text-center'>
          <h2 className='text-4xl font-extrabold tracking-tight text-white md:text-5xl'>
            {t('From idea to video in minutes')}
          </h2>
        </div>
        <div className='grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5'>
          {STEPS.map(([number, title, description]) => (
            <div
              key={number}
              className='rounded-2xl border border-white/10 bg-white/[0.04] p-8'
            >
              <div className='text-sm font-bold tracking-widest text-indigo-300'>
                {number}
              </div>
              <h3 className='mt-3 text-xl font-bold text-white'>{t(title)}</h3>
              <p className='mt-2 leading-relaxed text-slate-400'>
                {t(description)}
              </p>
            </div>
          ))}
        </div>
        <div className='mt-12 text-center'>
          <Link
            href='/ai-videos'
            className='inline-flex h-[54px] items-center justify-center rounded-full bg-indigo-500 px-10 text-lg font-bold text-white shadow-[0_8px_40px_-8px_rgba(99,102,241,0.7)] transition-all hover:bg-indigo-400'
          >
            {t('Make your first video')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default VideoSteps;
